import _ from 'lodash'
import immutable from 'immutable'
import moment from 'moment'

import {SOCKET_ROOM} from './socket.room'


const encoders = {
    immutable: {
        test: immutable.Iterable.isIterable,
        serialize: (val) => {
            val = val.toJS()
            val.__immutable = true
            return val
        },
        isSerialized: (val) => _.has(val, '__immutable'),
        deserialize: (val) => {
            val = immutable.fromJS(val)
            delete val.__immutable
            return val
        }
    }
}

const serializeVal = (val) => {
    for (let key in encoders) {
        let encoder = encoders[key]

        if (encoder.test(val)) {
            return encoder.serialize(val)
        }
    }

    return val
}

const deserializeVal = (val) => {
    for (let key in encoders) {
        let encoder = encoders[key]

        if (encoder.isSerialized(val)) {
            return encoder.deserialize(val)
        }
    }

    return val
}


export const socketUtil = {
    serialize: function(obj) {
        return _.mapValues(obj, serializeVal)
    },

    deserialize: function(obj) {
        return _.mapValues(obj, deserializeVal)
    },

    getRealtimeParams: function(params) {
        let defaults = {
            room: SOCKET_ROOM.DEFAULT
        }

        if (params === true) {
            return defaults
        }

        return _.defaults(params, defaults)
    },

    prepareAction: function(action) {
        let params = this.getRealtimeParams(action.realtime)

        let message = _.cloneDeep(action)
        delete message.realtime

        message = this.serialize(message)

        return [params, message]
    }
}
